// extracted by mini-css-extract-plugin
export var textInput = "_k3-0";